// Toast.js
import React, { useEffect } from 'react';

const Toast = ({ message, onClose, duration = 1000 }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [onClose, duration]);

    return (
        <div style={{
            position: 'fixed',
            bottom: '20px',       // move to bottom
            left: '50%',          // center horizontally
            transform: 'translateX(-50%)', // adjust for true center
            background: '#f44336',
            color: '#fff',
            padding: '12px 20px',
            borderRadius: '4px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            zIndex: 9999,
            textAlign: 'center',
            minWidth: '200px'
        }}>
            {message}
        </div>
    );
};

export default Toast;
